<script>
import options from './SupportSelector.options'
export default options
</script>

<template>
  <article class="kb-support-selector kb-optimizely-forms">
    <template v-for="(config, index) in supportSelectorConfig" :key="index">
      <div class="kb-support-selector__group" v-if="config.shown">
        <div
          class="kb-support-selector__group__select Form__Element FormSelection"
          :class="config.required ? 'ValidationRequired' : ''"
        >
          <label :for="config.id" class="Form__Element__Caption">{{
            config.label
          }}</label>
          <select
            :name="config.id"
            :id="config.id"
            :title="config.label"
            :aria-required="config.required"
            v-on:change="config.handler"
            v-on:blur="config.validator"
            :class="
              !config.isValid && displayInputError ? 'validation-error' : ''
            "
          >
            <option
              :value="config.defaultOption.value"
              :selected="config.defaultOption.selected"
            >
              {{ config.defaultOption.name }}
            </option>
            <template v-for="(option, index) in config.options" :key="index">
              <option :value="option.value" :selected="option.selected">
                {{ option.name }}
              </option>
            </template>
          </select>
        </div>

        <span
          v-if="!config.isValid && displayInputError"
          class="kb-forms Form__Element__ValidationError"
        >
          {{ config.errorMessage }}
        </span>
      </div>
    </template>
  </article>
</template>
